export const COMPARE = '/compare';
